<template lang="">
  <v-row>
    <UserInfoSideBar />
    <v-container justify-start>
      <v-row>
        <span class="font-weight-black text-h6 mt-7 ml-10">お気に入りユーザー一覧</span>
      </v-row>
      <template v-if="loading">
        <v-row justify="center" align-content="center" class="mt-10">
          <img src="../../assets/loading.gif">
        </v-row>
      </template>
      <template>
        <v-row class="mt-5 mx-12" v-if="isNotUsers">
          <v-col
            v-for="(item, i) in users"
            :key="i"
          >
            <v-badge
              overlap
              left
              offset-x=64
              offset-y=44
              color="black"
              class="font-weight-black"
              :value="item.unread_topics_count > 0 ? true : false"
              content="NEW"
            >
              <v-card
                class="mx-auto mt-0 d-flex flex-column"
                width="306"
                height="300"
                outlined
              >
                <router-link :to="{ name: 'user', params: { user_code: item.user_code }}" style="text-decoration: none; margin-left: auto; margin-right: auto;" class="mt-8">
                  <v-avatar size="140" depressed>
                      <v-img :src="item.icon_url" alt="icon" max-height="140" max-width="140"></v-img>
                  </v-avatar>
                </router-link>
                <v-card-title class="justify-center">{{ item.name }}</v-card-title>
                <v-card-subtitle class="justify-center" style="margin-left: auto; margin-right: auto;">{{ item.user_code }}</v-card-subtitle>
                <v-spacer></v-spacer>
                <v-divider class=""></v-divider>
                <v-card-actions>
                  <div class="text-caption">トピック総数：{{ item.total_topic_count }}</div>
                  <div class="text-caption ml-auto"><v-icon>mdi-heart</v-icon>{{ item.liked }}</div>
                </v-card-actions>
              </v-card>
            </v-badge>
          </v-col>
        </v-row>
        <v-row v-else>
          <p class="ml-10 mt-5">お気に入りしたユーザーはいません</p>
        </v-row>
      </template>
    </v-container>
  </v-row>
</template>
<script>
import UserInfoSideBar from '../organisms/UserInfoSideBar'

export default {
  name: 'FavoriteUserList',
  components :{
    UserInfoSideBar,
  },
  data() {
    return {
      loading: true,
      drawer: true,
      user: {},
      users:[],
      user_code:'',
      total_count:null,
      isNotUsers: true,
    }
  },
  created: function () {
    this.loading = true;
    this.loading = true;
    this.user_code = this.$store.getters['auth/isUserCode'];
    this.$store.dispatch('favorite/users')
      .then(() => {
        this.users = this.$store.getters['favorite/users'];
        this.total_count = this.users.length;
        if (this.total_count === 0) {
          this.isNotUsers = false;
        }
      });
    this.loading = false;
  },
  computed: {
    icon: function() {
      return this.user.icon_url
    },
  },
}
</script>